import { render, staticRenderFns } from "./CollectionInspiration.vue?vue&type=template&id=07175e3a&name=collection-inspiration&"
import script from "./CollectionInspiration.vue?vue&type=script&lang=js&"
export * from "./CollectionInspiration.vue?vue&type=script&lang=js&"
import style0 from "./CollectionInspiration.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports